import { render } from "./InvoicePayment.vue?vue&type=template&id=9a8f6bb8&scoped=true"
import script from "./InvoicePayment.vue?vue&type=script&lang=js"
export * from "./InvoicePayment.vue?vue&type=script&lang=js"

import "./InvoicePayment.vue?vue&type=style&index=0&id=9a8f6bb8&lang=sass&scoped=true"
import "./InvoicePayment.vue?vue&type=style&index=1&id=9a8f6bb8&lang=sass"
script.render = render
script.__scopeId = "data-v-9a8f6bb8"

export default script